import forgotCredentialsModule from "../../forgotCredentials/forgotCredentialsModule";

const forgotCredentialsConstants = {
    templates: {
        forgotCredentials: "forgot-credentials"
    },
    urls: {
        getMetadata: "/v2/recovery/metadata",
        getPasswordByEmail: "/Login/GetPasswordByEmail",
        sendPasswordReset: "/v2/passwords/reset/send",
        verifyCode: "/v2/passwords/reset/verify",
        resetPassword: "/login/reset-password",
        resetPasswordV3Params: "?version=3&ticket=",
        recoverUsername: "/v1/usernames/recover"
    },
    pages: {
        securityNotification: "SecurityNotification"
    },
    transmissionTypes: {
        email: "Email",
        sms: "Sms"
    },
    targetTypes: {
        email: "Email",
        phoneNumber: "PhoneNumber"
    },
    passwordErrorCodes: {
        flooded: 2,
        invalidTarget: 10,
        captcha: 18
    },
    usernameErrorCodes: {
        tooManyAttempts: 11,
        invalidEmail: 20,
        invalidPhone: 21,
        noAccountFound: 23
    },
    events: {
        formInteractionEventType: "formInteraction",
        buttonClickEventType: "buttonClick",
        recoverCredentialsCtx: "recoverCredentials",
        forgotPasswordUseEmailBtn: "forgotPasswordUseEmail",
        forgotUsernameUseEmailBtn: "forgotUsernameUseEmail",
        forgotPasswordUsePhoneBtn: "forgotPasswordUsePhone",
        forgotUsernameUsePhoneBtn: "forgotUsernameUsePhone",
        usePhoneToResetBtn: "usePhoneToReset",
        useEmailToResetBtn: "useEmailToReset",
    },
    ixp: {
        usernameDeprecationExperimentLayer: "Website.Login",
    },
};

forgotCredentialsModule.constant("forgotCredentialsConstants", forgotCredentialsConstants);

export default forgotCredentialsConstants;